module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6cd3d9e09b16222b242f5e2d77f8a62a.png";